// Theme-scoped presentation only; conversations and hosted iframe remain owned by Shopify.
const chat = document.querySelector('shopify-chat[data-jayce-avatar]');
if (chat) {
  let retries = 0;
  let observer;
  const dismissalKey = 'mox-jayce-invitation-dismissed-v1';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(dismissalKey) === '1'; } catch (_) {}
  const boundActivators = new WeakSet();
  const mobileViewport = window.matchMedia('(max-width: 767px)');
  const dismissInvitation = () => {
    dismissed = true;
    try { sessionStorage.setItem(dismissalKey, '1'); } catch (_) {}
    connect();
  };
  const image = (launcher = false) => {
    const img = document.createElement('img');
    const source = new URL(chat.dataset.jayceAvatar);
    source.searchParams.set('width', '80');
    img.src = source.href;
    source.searchParams.set('width', '160');
    img.srcset = `${img.src} 80w, ${source.href} 160w`;
    img.sizes = launcher ? '(max-width: 767px) 48px, 56px' : '40px';
    img.width = launcher ? 56 : 40;
    img.height = launcher ? 56 : 40;
    img.alt = chat.dataset.jayceAlt;
    img.decoding = 'async';
    img.style.cssText = 'object-fit:cover;border-radius:50%;flex:none';
    if (launcher) img.className = 'mox-jayce-launcher-avatar';
    else img.style.cssText += ';width:40px;height:40px';
    return img;
  };
  const connect = () => {
    const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot || chat.shadowRoot;
    const header = root?.querySelector('.panel__header');
    const activator = root?.querySelector('[part="activator"]');
    if (!activator) {
      if (root) {
        observer?.disconnect();
        observer = new MutationObserver(connect);
        observer.observe(root, {childList:true, subtree:true});
        if (root !== chat.shadowRoot) observer.observe(chat.shadowRoot, {childList:true, subtree:true});
      } else if (++retries < 20) setTimeout(connect, 500);
      return;
    }
    observer?.disconnect();
    if (!root.querySelector('[data-mox-jayce-style]')) {
      const style = document.createElement('style');
      style.dataset.moxJayceStyle = '';
      style.textContent = "[part=\"activator\"]{width:auto!important;max-width:calc(100vw - 32px);min-height:72px!important;padding:8px 16px 8px 8px!important;gap:10px!important;border:1px solid #d9b568!important;border-radius:40px!important;background:linear-gradient(135deg,#3b2b20,#241910)!important;color:#fff4dc!important;box-shadow:0 4px 22px #21130d38,0 0 0 3px #d9b56820!important}\n[part=\"activator\"] .activator__icon{width:56px!important;height:56px!important;flex:none;overflow:visible}\n.mox-jayce-launcher-avatar{display:block;width:56px;height:56px;box-shadow:0 0 0 2px #d9b56880;animation:mox-jayce-welcome 4s ease-in-out 1}\n[part=\"activator\"] .activator__label{display:block!important;white-space:pre-line!important;text-align:left;color:#fff4dc!important;opacity:1!important;max-width:156px;animation:mox-jayce-reveal .25s ease-out both;font-size:13px!important;line-height:1.4!important;font-weight:600!important}\n[part=\"activator\"]:focus-visible{outline:3px solid #fff4dc!important;outline-offset:4px}\n[part=\"activator\"]:hover .mox-jayce-launcher-avatar,[part=\"activator\"]:focus-visible .mox-jayce-launcher-avatar{animation-play-state:paused}\n@keyframes mox-jayce-reveal{from{opacity:0;transform:translateY(3px)}to{opacity:1;transform:translateY(0)}}\n@keyframes mox-jayce-welcome{0%,100%{transform:translateY(0)}35%,65%{transform:translateY(-2px) scale(1.025)}}\n@media(max-width:767px){[part=\"activator\"]{min-height:64px!important;padding:7px 12px 7px 7px!important;gap:8px!important}\n[part=\"activator\"] .activator__icon,.mox-jayce-launcher-avatar{width:48px!important;height:48px!important}\n[part=\"activator\"] .activator__label{font-size:12px!important;max-width:132px}}\n@media(prefers-reduced-motion:reduce){[part=\"activator\"] .activator__label,.mox-jayce-launcher-avatar{animation:none!important;transform:none!important}}";
      style.textContent += "\n[part=\"activator\"]{border-radius:18px!important;max-width:min(332px,calc(100vw - 32px))!important}\n[part=\"activator\"] .activator__label{position:relative;max-width:230px!important;font-weight:400!important;padding-left:10px;border-left:1px solid #d9b56880}\n[part=\"activator\"] .activator__label:before{content:\"\";position:absolute;left:-5px;top:50%;width:8px;height:8px;transform:translateY(-50%) rotate(45deg);background:#33251c;border-left:1px solid #d9b56880;border-bottom:1px solid #d9b56880}\n.mox-jayce-speaker{display:block;font-size:10px;font-weight:500;line-height:1.35;color:#d9bf8b;margin-bottom:3px}\n.mox-jayce-speech{display:block;font-size:13px;line-height:1.4;font-weight:400}\n@media(max-width:767px){[part=\"activator\"]{max-width:300px!important}.mox-jayce-speech{font-size:12px}[part=\"activator\"] .activator__label{max-width:210px!important}}\n";
      // Keep the close button a sibling: interactive controls cannot be nested.
      style.textContent += `
.mox-jayce-controls{display:flex!important;align-items:flex-start;gap:4px}
.mox-jayce-controls [part="activator"]{max-width:min(288px,calc(100vw - 84px))!important}
.mox-jayce-dismiss{display:inline-flex;align-items:center;justify-content:center;flex:0 0 44px;width:44px;height:44px;margin:0;padding:0;border:1px solid #d9b568;border-radius:50%;background:#241910;color:#fff4dc;font:26px/1 sans-serif;cursor:pointer}
.mox-jayce-dismiss:focus-visible{outline:3px solid #fff4dc;outline-offset:3px}
.mox-jayce-dismiss[hidden]{display:none!important}
[part="activator"].mox-jayce-compact{width:72px!important;min-width:0!important;padding:8px!important;gap:0!important;border-radius:50%!important}
[part="activator"].mox-jayce-compact .activator__label{display:none!important}
  .mox-jayce-controls .activator__icon{position:relative}
  .mox-jayce-controls .activator__icon::after{
    content:"";position:absolute;right:-2px;bottom:-2px;
    width:10px;height:10px;border:2px solid #241910;border-radius:50%;
    background:#54d487;pointer-events:none;
  }
@media(max-width:767px){
  /* Only the launcher's own wrapper moves; the panel/host keep Shopify geometry. */
  .activator-nudge--right.mox-jayce-controls{
    position:fixed!important;
    left:max(16px,env(safe-area-inset-left,0px))!important;
    bottom:max(16px,env(safe-area-inset-bottom,0px))!important;
    right:auto!important;top:auto!important;
    width:64px!important;max-width:64px!important;
    margin:0!important;transform:none!important;
  }
  .mox-jayce-controls [part="activator"],
  [part="activator"].mox-jayce-compact{
    box-sizing:border-box!important;width:64px!important;height:64px!important;
    min-width:64px!important;min-height:64px!important;max-width:64px!important;
    padding:7px!important;gap:0!important;border-radius:50%!important;
  }
  .mox-jayce-controls .activator__label,
  .mox-jayce-controls .mox-jayce-dismiss{display:none!important}

}
`;
      root.append(style);
    }
    const apply = () => {
      const controls = activator.parentElement;
      controls.classList.add('mox-jayce-controls');
      activator.classList.toggle('mox-jayce-compact', dismissed);
      let close = controls.querySelector('.mox-jayce-dismiss');
      if (!close) {
        close = document.createElement('button');
        close.type = 'button';
        close.className = 'mox-jayce-dismiss';
        close.setAttribute('aria-label', chat.dataset.jayceDismiss);
        close.textContent = '×';
        close.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          dismissInvitation();
          activator.focus({preventScroll: true});
        });
        controls.append(close);
      }
      close.hidden = dismissed;
      if (!boundActivators.has(activator)) {
        // Opening the chat also consumes this session's invitation.
        activator.addEventListener('click', dismissInvitation);
        boundActivators.add(activator);
      }
      const title = root.querySelector('#shopify-agent-panel-title');
      if (title && title.textContent !== chat.dataset.jayceTitle) title.textContent = chat.dataset.jayceTitle;
      const mobileLabel = document.documentElement.lang.startsWith('fr')
        ? 'Ouvrir Jayce, assistant automatique disponible'
        : 'Open Jayce, automated assistant available';
      const launcherLabel = mobileViewport.matches ? mobileLabel : chat.dataset.jayceLabel;
      if (activator.getAttribute('aria-label') !== launcherLabel) activator.setAttribute('aria-label', launcherLabel);
      if (mobileViewport.matches) activator.setAttribute('title', mobileLabel);
      else activator.removeAttribute('title');
      const label = activator.querySelector('.activator__label');
      const prompt = chat.dataset.jaycePrompt;
      if (label && (label.querySelector('.mox-jayce-speech')?.textContent !== prompt || !label.querySelector('.mox-jayce-speaker'))) {
        const speaker = document.createElement('span');
        speaker.className = 'mox-jayce-speaker';
        speaker.textContent = chat.dataset.jayceSpeaker;
        const speech = document.createElement('span');
        speech.className = 'mox-jayce-speech';
        speech.textContent = prompt;
        label.replaceChildren(speaker, speech);
      }
      const icon = activator.querySelector('.activator__icon');
      if (icon && !icon.querySelector('img')) { icon.replaceChildren(image(true)); }
      if (header && !header.querySelector('[data-mox-jayce]')) {
        const identity = document.createElement('span');
        identity.dataset.moxJayce = '';
        identity.style.cssText = 'display:flex;align-items:center;gap:8px;min-width:0;color:inherit;font:inherit;margin-inline-end:auto';
        identity.append(image());
        const name = document.createElement('strong');
        name.textContent = chat.dataset.jayceTitle;
        name.style.cssText = 'max-width:130px;line-height:1.25;font-size:13px;overflow-wrap:anywhere';
        identity.append(name);
        header.prepend(identity);
      }
    };
    apply();
    chat.removeAttribute('data-jayce-pending');
    observer = new MutationObserver(connect);
    observer.observe(root, {childList:true, subtree:true});
    if (root !== chat.shadowRoot) observer.observe(chat.shadowRoot, {childList:true, subtree:true});
  };
  customElements.whenDefined('shopify-chat').then(connect);
  mobileViewport.addEventListener('change', connect);
  window.addEventListener('pagehide', () => observer?.disconnect());
  window.addEventListener('pageshow', event => { if (event.persisted) connect(); });
}
